/** Eventos WebSocket (namespace /game). São notificações: o cliente relê via REST. */
export const WS_NAMESPACE = '/game';

export const WS_EVENTS = [
  'turn:resolving',
  'turn:resolved',
  'news:edition',
  'timer:completed',
  'intel:report',
  'radar:contact',
  'diplomacy:update',
  'trade:offer',
  'chat:message',
  'state:changed',
  'match:updated',
  'objective:completed',
] as const;
export type WsEvent = (typeof WS_EVENTS)[number];

export interface WsPayloads {
  'turn:resolving': { matchId: string; turn: number };
  'turn:resolved': { matchId: string; turn: number; nextTurnAt: string | null };
  'news:edition': { matchId: string; turn: number; count: number };
  'timer:completed': { matchId: string; kind: string; data: Record<string, unknown> };
  'intel:report': { matchId: string; target: string };
  'radar:contact': { matchId: string; location: string };
  'diplomacy:update': { matchId: string; kind: string };
  'trade:offer': { matchId: string; offerId: string };
  /** `channel` é o armazenado ('global' | 'alliance' | 'dm'); `preview` é o começo do texto. */
  'chat:message': {
    matchId: string;
    channel: string;
    id: string;
    from: { playerId: string; government: string };
    preview: string;
  };
  'state:changed': { matchId: string; reason: string };
  'match:updated': { matchId: string };
  'objective:completed': { matchId: string; kind: string; data: Record<string, unknown> };
}

export function matchRoom(matchId: string): string {
  return `match:${matchId}`;
}
export function playerRoom(matchId: string, playerId: string): string {
  return `match:${matchId}:player:${playerId}`;
}
export function allianceRoom(matchId: string, allianceId: string): string {
  return `match:${matchId}:alliance:${allianceId}`;
}

/** Id estável da "aliança" de um par/grupo (ordenado) para a sala de aliança. */
export function allianceId(members: string[]): string {
  return [...members].sort().join('+');
}
